import React from 'react';
import { UsersIcon, PlusIcon } from 'lucide-react';
interface SocialCardProps {
  title: string;
  description: string;
  eventName: string;
  eventDate: string;
}
export const SocialCard = ({
  title,
  description,
  eventName,
  eventDate
}: SocialCardProps) => {
  return <div className="bg-[#2C2F33] rounded-xl overflow-hidden hover:shadow-lg transition-shadow" data-id="element-175">
      <div className="p-4" data-id="element-176">
        <div className="flex items-center mb-3" data-id="element-177">
          <div className="w-8 h-8 bg-[#007BFF] bg-opacity-20 rounded-full flex items-center justify-center mr-2" data-id="element-178">
            <UsersIcon size={16} className="text-[#007BFF]" data-id="element-179" />
          </div>
          <span className="text-[#F5F5F7] font-medium" data-id="element-180">Social Planning</span>
        </div>
        <h3 className="text-[#F5F5F7] font-bold text-lg mb-2" data-id="element-181">{title}</h3>
        <p className="text-gray-300 text-sm mb-3" data-id="element-182">{description}</p>
        <div className="bg-[#1A1A1D] rounded-lg p-3 mb-4" data-id="element-183">
          <p className="text-[#F5F5F7] font-medium" data-id="element-184">{eventName}</p>
          <p className="text-gray-400 text-sm" data-id="element-185">{eventDate}</p>
        </div>
        <button className="bg-gradient-to-r from-sky-500 to-blue-600 text-white px-4 py-2 rounded-lg font-medium hover:from-sky-600 hover:to-blue-700 transition-colors w-full flex items-center justify-center" data-id="element-186">
          <PlusIcon size={18} className="mr-2" data-id="element-187" />
          Create Plan
        </button>
      </div>
    </div>;
};